export default function ValidatePhone(phone) {
  if (!phone) {
    return false;
  } else if (!/(^|\W)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g.test(phone)) {
    return false;
  }

  return true;
};